





















































































































































import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { i18n } from "@/resources/locales";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import UserValidator from "@/resources/mixins/userValidator";
import { ROOM_TYPE } from "@/resources/constants/space";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { PLAN } from "@/resources/constants/plan";
import Plans from "@/resources/mixins/plans/plans";
@Component({
  name: "floatingMenu-component",
})
export default class FloatingMenuComponent extends mixins(
  NotificationEvent,
  UserValidator,
  Plans
) {
  ROOM_TYPE = ROOM_TYPE;
  MEETING_TYPE = MEETING_TYPE;
  PLAN = PLAN;
  date = "";
  activeMenu = false;
  activePoll = false;
  question = "";
  response1 = "";
  response2 = "";
  response3 = "";
  response4 = "";
  response5 = "";
  duration = 1;
  pollOptions = [];
  isNotCreated = true;
  get room(): any {
    return this.$store.getters["SystemStore/getCurrentRoom"];
  }
  get isMultiWebinar(): boolean {
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    return (
      meetingType === MEETING_TYPE.WEBINAR &&
      space.superSpace.isMultiWebinarActivated
    );
  }
  get meetingType(): string {
    return this.$store.getters["MeetingStore/getMeetingType"];
  }
  destroyed(): void {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
  openNotepad() {
    if (!this.activeOptionPlan(PLAN.NOTEPAD))
      return;
    this.$store?.dispatch("SystemStore/setOpenNotepadModalAction", true);
    this.activeMenu = false;
  }
  openPoll() {
    if (!this.activeOptionPlan(PLAN.POLL)) return;
    this.activePoll = true;
    this.activeMenu = false;
  }
  createPoll() {
    if (!this.activeOptionPlan(PLAN.POLL)) return;
    this.isNotCreated = false;
    const currentRoom = this.$store.getters["SystemStore/getCurrentRoom"];
    if (this.response1) this.pollOptions.push({ title: this.response1 });
    if (this.response2) this.pollOptions.push({ title: this.response2 });
    if (this.response3) this.pollOptions.push({ title: this.response3 });
    if (this.response4) this.pollOptions.push({ title: this.response4 });
    if (this.response5) this.pollOptions.push({ title: this.response5 });
    this.$store.dispatch("PollStore/createPollAction", {
      roomId: currentRoom.id,
      data: {
        question: this.question,
        pollOptions: this.pollOptions,
        duration: parseInt(this.duration.toString()),
      },
      callback: (response) => {
        this.question = "";
        this.response1 = "";
        this.response2 = "";
        this.response3 = "";
        this.response4 = "";
        this.response5 = "";
        this.duration = 1;
        this.pollOptions = [];
        this.activePoll = false;
        this.isNotCreated = true;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("poll.pollSuccessNotifications")
        );
      },
      callbackError: (error) => {
        this.isNotCreated = false;
        this.onError(
          i18n.t(""),
          i18n.t("notifications.genericError.genericErrorRetry")
        );
      },
    });
  }
  checkResponse() {
    let checkOk1 = false;
    let checkOk2 = false;
    let validCounter = 0;
    if (this.response1.trim().length > 0) validCounter++;
    if (this.response2.trim().length > 0) validCounter++;
    if (this.response3.trim().length > 0) validCounter++;
    if (this.response4.trim().length > 0) validCounter++;
    if (this.response5.trim().length > 0) validCounter++;
    if (this.question.trim().length > 0) checkOk1 = true;
    if (validCounter >= 2) checkOk2 = true;
    return checkOk1 && checkOk2 && this.isNotCreated ? false : true;
  }
}
